(() => {
  if (window.__gutsuppCartUpgradeBound) return;
  window.__gutsuppCartUpgradeBound = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-upgrade]');
    if (!button || window.__gutSuppGiftUi) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const status = button.closest('form')?.querySelector('.cro-cart-status');
    if (status) status.textContent = button.dataset.upgradeError || window.GutSuppCartGifts?.config?.error || '';
  }, true);
})();
